/* eslint-disable camelcase */
import { convertStrDateToDMFormat } from '@beef/shop-common';

import { DELIVERY_TAKEAWAY_OFFICE, POINT_TYPES } from 'store/ProductCatalog/constants';

export const setTakeawayOffices = (
  list,
  { headers, paymentPointText, onlyOnlinePaymentText, onlyOnlinePaymentThankYouPageText },
) =>
  list.map((item) => {
    if (item.ptype === DELIVERY_TAKEAWAY_OFFICE) {
      item.name = headers[(item.point_type || {}).slug || item.ptype];
      item.availableDate = 'Сегодня и позднее';
    } else if (item.delivery_days && item.delivery_days.length !== 0) {
      item.minDate = item.delivery_days.reduce((prevDate, date) =>
        prevDate < date ? prevDate : date,
      );
      item.availableDate = `${convertStrDateToDMFormat(item.minDate)} и позднее`;
    }

    if (item.ptype === 'partner') {
      item.availableDate = null;
    }

    if (item.only_card_online) {
      item.onlyCardTitle = `${onlyOnlinePaymentText}`;
      item.onlyCardThankYouTitle = `${onlyOnlinePaymentThankYouPageText}`;
    }

    item.priceTitle = item.price > 0 ? `Стоимость ${item.price} ₽` : 'Бесплатно';
    item.priceSubTitle = item.price > 0 ? `${paymentPointText}` : null;
    return item;
  });

export const convertLegacyPaymentOffice = ({
  movement_date: movementDate,
  movement_id: movementId,
  equipment_id: equipmentId,
  movement_time: movementTime,
  point_type: pointType,
  only_card_online: onlyCard,
  delivery_days: deliveryDays,
  availableDate,
  address,
  pointCode,
  latitude,
  longitude,
  nearestSubway,
  nearestSubwayLineColor,
  opening,
  only_card_online,
  onlyCardTitle,
  phone,
  price,
  name,
  partner,
  dop_info,
  dopInfo,
}) => ({
  name,
  phone,
  address,
  pointCode,
  latitude,
  longitude,
  nearestSubway,
  nearestSubwayLineColor,
  movement_date: movementDate,
  movement_id: movementId,
  equipment_id: equipmentId,
  movement_time: movementTime,
  delivery_days: deliveryDays,
  availableDate,
  only_card_online,
  onlyCard,
  onlyCardTitle,
  opening,
  partner,
  price,
  point_type: pointType,
  dop_info: dopInfo || dop_info,
  ptype: POINT_TYPES[(pointType || {}).slug] ? (pointType || {}).slug : DELIVERY_TAKEAWAY_OFFICE,
  subway:
    nearestSubway && nearestSubwayLineColor ?
      {
        name: nearestSubway,
        color: nearestSubwayLineColor,
      }
    : null,
});

export const convertLegacyPaymentNewOffice = ({
  address,
  availableDate,
  code,
  deliveryDays,
  dopInfo,
  lat,
  lon,
  name,
  nearestSubway,
  onlyCardOnline,
  onlyCard,
  onlyCardTitle,
  opening,
  partner,
  pointType,
  price,
  telephone,
  movementDate,
  movementId,
  equipmentId,
  movementTime,
}) => ({
  address,
  availableDate,
  delivery_days: deliveryDays,
  dop_info: dopInfo,
  latitude: lat,
  longitude: lon,
  movement_date: movementDate || null,
  movement_id: movementId || 0,
  equipment_id: equipmentId || null,
  movement_time: movementTime || null,
  name,
  nearestSubway: nearestSubway ? nearestSubway.name : null,
  nearestSubwayLineColor: nearestSubway ? nearestSubway.lineColor : null,
  onlyCard,
  onlyCardTitle,
  only_card_online: onlyCardOnline,
  opening,
  partner,
  phone: telephone,
  pointCode: code,
  point_type: pointType,
  price,
  ptype: POINT_TYPES[(pointType || {}).slug] ? (pointType || {}).slug : DELIVERY_TAKEAWAY_OFFICE,
  subway:
    nearestSubway ?
      {
        color: nearestSubway.lineColor,
        name: nearestSubway.name,
      }
    : null,
});

export const mapNewOffices = (offices) =>
  offices.map((office) => convertLegacyPaymentNewOffice(office));
export const mapOffices = (rawOffices) =>
  rawOffices.map((office) => convertLegacyPaymentOffice(office));
